import axios from './index';

export const getRouteCategoryRequest = (filterObj = {}) => {
  const { issuerID, accessStatus } = filterObj;
  return axios.get(
    `v1/admins/route-categories/get/route-categories/-/${issuerID || '-'}/${
      accessStatus || '-'
    }/-/-`
  );
};

export const getIssuerRouteCategoryRequest = (filterObj = {}) => {
  const { issuerID, accessStatus } = filterObj;
  return axios.get(
    `v1/issuer-staffs/route-categories/get/route-categories/-/-/-`
  );
};

export const createRouteCategoryRequest = (payload) =>
  axios.post('v1/admins/route-categories/create/route-category', payload);

export const updateRouteCategoryRequest = (id, payload) =>
  axios.put(`v1/admins/route-categories/update/route-category/${id}`, payload);

export const toggleRouteCategoryRequest = (id, payload) =>
  axios.put(
    `v1/admins/route-categories/toggle/route-category/${id}/access-status`,
    payload
  );

export const deleteRouteCategoryRequest = (id) =>
  axios.delete(`v1/admins/route-categories/delete/route-category/${id}`);
